var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! Na aba MONITORAMENTO POR UNIDADE você encontra dois filtros de seleção: "
        ),
      ]),
      _c("div", { staticClass: "d-flex justify-center" }, [
        _c(
          "p",
          {
            staticClass:
              "col-6 mx-2 pa-2 text-start font-weight-medium text-lg-h6",
          },
          [
            _vm._v(" No filtro "),
            _c("b", [_vm._v("Selecione a unidade")]),
            _vm._v(
              ", posicionado do lado esquerdo, está selecionada sua unidade organizacional. "
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass:
              "col-6 mx-2 pa-2 text-start font-weight-medium text-lg-h6",
          },
          [
            _vm._v(" No filtro "),
            _c("b", [_vm._v("Selecione o Tipo de monitoramento")]),
            _vm._v(", posicionado no lado direito, você pode selecionar: "),
            _c("br"),
            _vm._v(" (1) "),
            _c("b", [_vm._v("Comportamentos;")]),
            _c("br"),
            _vm._v(" (2) "),
            _c("b", [_vm._v("Competências Comportamentais.")]),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("1. Comportamentos")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" Ao selecionar (1) "),
            _c("b", [_vm._v("Monitoramento de Comportamentos")]),
            _vm._v(
              ", é possível analisar, por meio de gráficos e tabelas, os dados referentes a participação dos servidores no mapeamento comportamental da sua unidade. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-center font-weight-bold text-lg-h6" },
          [_vm._v(" Gráfico de barras, pizzas e tabela ")]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " No gráfico de barras serão apresentadas informações sobre quantos comportamentos cada servidor cadastrou no período da realização do mapeamento comportamental. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " No gráfico pizza, pode-se observar qual a maior tendência entre os comportamentos cadastrados pelos servidores da sua unidade: comportamentos que gostam, que não gostam ou que seriam ideais para seu ambiente de trabalho. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na tabela é possível observar a relação dos servidores da unidade e utilizar os recursos de ordenação, de forma crescente ou decrescente, por nome do servidor e quantidade de comportamentos. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("2. Competências Comportamentais")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" Ao selecionar (2) "),
            _c("b", [_vm._v("Monitoramento de Competências Comportamentais")]),
            _vm._v(
              ", é possível verificar, por meio de gráficos e tabelas, a distribuição dos comportamentos cadastrados pelos servidores da sua unidade, associados às Competências Comportamentais. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-center font-weight-bold text-lg-h6" },
          [_vm._v(" Gráfico de barras, pizzas e tabela ")]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " No gráfico de barras, recomenda-se observar as competências com maior barra (representa o maior número de comportamentos associados) e as competências com menor número de comportamentos ou sem comportamentos associados (sem barra). Recomenda-se ainda verificar a categoria "
            ),
            _c("b", [_vm._v("“outros”")]),
            _vm._v(". Essa categoria inclui todos os cadastros que "),
            _c("b", [_vm._v("não")]),
            _vm._v(" são considerados comportamentos. "),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Outra forma de observar a associação dos comportamentos às competências é por meio de percentuais, como apresenta o gráfico pizza. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na tabela é possível observar de forma mais sintética as doze competências comportamentais definidas para o Programa de Gestão por Competências e a categoria "
            ),
            _c("b", [_vm._v("“outros”")]),
            _vm._v(". "),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("div", { staticClass: "mx-2 pa-2 justify-center" }, [
        _c("ul", [
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Recomenda-se visitar essa aba "),
                _c("b", [_vm._v("MONITORAMENTO POR UNIDADE")]),
                _vm._v(", filtro 1. "),
                _c("b", [_vm._v("COMPORTAMENTOS")]),
                _vm._v(
                  ", para acompanhar a evolução da participação dos servidores no período do Mapeamento Comportamental; "
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Recomenda-se visitar essa aba "),
                _c("b", [_vm._v("MONITORAMENTO POR UNIDADE")]),
                _vm._v(", filtro 2. "),
                _c("b", [_vm._v("COMPETÊNCIAS COMPORTAMENTAIS")]),
                _vm._v(
                  ", após a conclusão do período do mapeamento comportamental, para identificar quais competências foram mais contempladas pela observação dos comportamentos dos servidores na sua unidade; "
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " Você pode trabalhar os dados expostos, por meio dos gráficos e tabelas, com sua equipe no intuito de verificar aspectos positivos e pontos de melhorias no contexto das competências destacadas; "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }